// extracted by css-extract-rspack-plugin
export default {"root":"root-FyestQ","count":"count-RPdWXe","pane":"pane-ZpqEWN text-lg"};